import { render, staticRenderFns } from "./AppInstall.vue?vue&type=template&id=1de4de78&scoped=true"
import script from "./AppInstall.vue?vue&type=script&lang=js"
export * from "./AppInstall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de4de78",
  null
  
)

export default component.exports